import { CodeComplexValue } from "app/area/shared/codetable/types";
import {
  CodetableWithCategoryIds, referenceRegularExpressionType
} from "app/area/codetable/common/merge-code/constants";

export const canMergeCode = (codetableId: number, canMerge: boolean, category: CodeComplexValue<number>) => {

  if (codetableId === CodetableWithCategoryIds.Reference && category?.value === referenceRegularExpressionType) {
    return false;
  }

  return canMerge;
};

export const canMergeWithCategory = (codetableId: number, categoryId: number) =>
  Object.values(CodetableWithCategoryIds).includes(codetableId) && !!categoryId;
